module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "sigil_not_in_toc"
  }, [_c('a', {
    attrs: {
      "id": "h2"
    }
  }), _vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop"
  }, [_vm._v("I wish to thank August Derleth for the loan of his set of volumes on famous American murders, Brian Marriner for unearthing some valuable press cuttings, Mrs Gita Whetter for correcting the manuscript and proof, and Dr Francis Camps, Ludovic Kennedy and S Foster Damon for help on particular points. The London Library, as usual, went to a great deal of trouble to search out essential material.")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop"
  }, [_vm._v("The following books have provided valuable material from which I have quoted: Herbert Asbury "), _c('i', [_vm._v("The Gangs of New York,")]), _vm._v(" G P Putnam’s Sons; Christopher Hibbert "), _c('i', [_vm._v("The Roots of Evil,")]), _vm._v(" Weidenfeld and Nicolson; Suzanne Lilar "), _c('i', [_vm._v("Aspects of Love in Western Society,")]), _vm._v(" Thames and Hudson; Sir Melville Macnaghten "), _c('i', [_vm._v("Day of my Years,")]), _vm._v(" Edward Arnold and Lytton Strachey "), _c('i', [_vm._v("Elizabeth and Essex,")]), _vm._v(" Chatto and Windus.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("CW")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dbc3425","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/03_acknowledgements.vue
// module id = 69
// module chunks = 0